
import { defineComponent, PropType } from 'vue';
import getAirport from '@white-label-helper/mixin-get-airport';
// Types
import type { CartItem, Item } from '@white-label-types/parking-checkout';

type SummaryElement = CartItem | Item;

export default defineComponent({
  name: 'SummaryAirport',
  mixins: [getAirport],
  props: {
    product: {
      type: Object as PropType<SummaryElement>,
      required: true,
    },
  },
});
